import { useSmoothScroll } from "@/hooks/useSmoothScroll";
import Intro from "@/components/Intro";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import Problem from "@/components/Problem";
import Services from "@/components/Services";
import Process from "@/components/Process";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import Seo from "@/components/Seo";
import { organizationSchema, offerCatalogSchema } from "@/lib/schema";
import { services } from "@/data/services";

const HOME_TITLE = "Kurpfalz Automation – Automatisierung für Handwerk, Praxen & Makler in der Rhein-Neckar-Region";
const HOME_DESCRIPTION =
  "Kurpfalz Automation – Automatisierung von Terminplanung, Lead-Erfassung und Kundenkommunikation für Handwerksbetriebe, Praxen und Immobilienverwalter in Mannheim, Heidelberg, Ludwigshafen, Weinheim und der gesamten Rhein-Neckar-Region.";

export default function LandingPage() {
  useSmoothScroll();
  return (
    <div className="min-h-screen bg-[#FAF8F2]" data-testid="landing-page">
      <Seo
        title={HOME_TITLE}
        description={HOME_DESCRIPTION}
        path="/"
        jsonLd={[organizationSchema(), offerCatalogSchema(services)]}
      />
      <Intro />
      <Header />
      <main>
        <Hero />
        <Problem />
        <Services />
        <Process />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
